import type { PortraitDef } from './portraits';

/**
 * Marco circular consistente para los retratos. El color nunca es el único
 * diferenciador de un personaje (eso lo decide la tarea de contenido con el nombre);
 * aquí solo se garantiza que la silueta se lea a tamaño pequeño (`sm`).
 */
export function Portrait({
  portrait,
  size = 'md',
  alt = '',
}: {
  portrait: PortraitDef;
  size?: 'sm' | 'md' | 'lg';
  /** Nombre del personaje cuando el retrato ya está asignado a uno; decorativo si no. */
  alt?: string;
}) {
  const px = size === 'sm' ? 32 : size === 'md' ? 48 : 96;
  return (
    <img
      src={portrait.src}
      alt={alt}
      width={px}
      height={px}
      className="border-border/60 rounded-full border"
      style={{ width: px, height: px }}
    />
  );
}
